export const parseDate = function(stringDate) {
  const date = new Date(stringDate);
  const month = function() {
    const montList = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    return montList[date.getMonth()];
  };
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
  const timeOfDay = hours <= 12 ? "am" : "pm";
  const minutes =
    date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();

  return `${month()} ${day}, ${year} ${hours}:${minutes} ${timeOfDay} EST`;
};

export const parseDateShort = function(stringDate) {
  const date = new Date(stringDate);
  const day = () => {
    const day = date.getDate();
    return day < 10 ? `0${day}` : day;
  };
  const month = () => {
    const month = date.getMonth() + 1;
    return month < 10 ? `0${month}` : month;
  };
  const year = date.getFullYear();

  return `${day()}.${month()}.${year}`;
};

export const cutString = function(str, length) {
  return str.length > length ? str.substr(0, length - 3) + "..." : str;
};

export const getSequence = function(n, offset = 0) {
  const sequence = [];
  for (let i = 0; i < n; i++) {
    sequence.push(i + offset);
  }
  return sequence;
};

export const getInstance = type =>
  ({}.toString.call(type).replace(/^(\[object )(\w+)(\])$/, "$2"));

export const isApropriateAge = (year, month, day) => {
  const age = new Date(year, month, day);
  const currentDate = new Date();
  const yearDiff = currentDate.getFullYear() - age.getFullYear();

  if (yearDiff > 18) {
    return true;
  } else if (yearDiff === 18) {
    const monthDiff = currentDate.getMonth() - age.getMonth();

    if (monthDiff > 0) {
      return true;
    } else if (monthDiff === 0) {
      const dayDiff = currentDate.getDate() - age.getDate();

      if (dayDiff >= 0) {
        return true;
      }
    }
  }

  return false;
};
